var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaypause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "#3751fe",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 9.631 43.702 L 9 44.333 9 100.108 L 9 155.882 9.750 156.317 L 10.500 156.752 58.500 128.985 L 106.500 101.219 107 128.860 L 107.500 156.500 123.250 156.775 L 139 157.051 139 100 L 139 42.949 123.250 43.225 L 107.500 43.500 107 71.127 L 106.500 98.755 60 71.840 L 13.500 44.926 11.881 43.998 L 10.263 43.070 9.631 43.702 M 161 100 L 161 157 177 157 L 193 157 193 100 L 193 43 177 43 L 161 43 161 100",
    stroke: "none",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaypause);
export default __webpack_public_path__ + "static/media/playpause.132b27083900e4e3bafe3667200a523c.svg";
export { ForwardRef as ReactComponent };